<template>
  <component :is="iconComponent" />
</template>

<script>
import IconAccount from "./account-outline.svg?inline";
import IconCardAccountDetails from "./card-account-details-outline.svg?inline";
import IconCardText from "./card-text-outline.svg?inline";
import IconHelpCircle from "./help-circle-outline.svg?inline";
import IconViewDashboard from "./view-dashboard-outline.svg?inline";
import IconAccountQuestion from "./account-question-outline.svg?inline";
import IconAccountSearch from "./account-search-outline.svg?inline";
import IconPower from "./power.svg?inline";
import IconLogout from "./logout.svg?inline";
import IconSoundOn from "./sound-on.svg?inline";
import IconSoundOff from "./sound-off.svg?inline";
import IconAlertCircle from "./alert-circle-outline.svg?inline";
import IconInformation from "./information-outline.svg?inline";
import IconCheck from "./check.svg?inline";
import IconCheckCircle from "./check-circle-outline.svg?inline";
import IconMagnify from "./magnify.svg?inline";
import IconRotateRight from "./rotate-right.svg?inline";
import IconChevronDown from "./chevron-down.svg?inline";
import IconChevronLeft from "./chevron-left.svg?inline";
import IconChevronRight from "./chevron-right.svg?inline";
import IconChevronUp from "./chevron-up.svg?inline";
import IconContentCopy from "./content-copy.svg?inline";
import IconOpenInNew from "./open-in-new.svg?inline";
import IconNewspaper from "./newspaper-variant-outline.svg?inline";
import IconRefresh from "./refresh.svg?inline";
import TypeGame from "./type-game.svg?inline";
import ComplianceReview from "./compliance-review.svg?inline";
import IconNFC from "./nfc.svg?inline";
import QRCode from "./qr-code.svg?inline";
import DarkMode from "./dark-mode.svg?inline";
import ArrowUp from "./arrow-up.svg?inline";
import ArrowDown from "./arrow-down.svg?inline";
import OriginalCharactersCheckActive from "./original-characters-check-active.svg?inline";
import OriginalCharactersCheckInactive from "./original-characters-check-inactive.svg?inline";
import IconNoMediaImage from "./no-media-image.svg?inline";

const icons = {
  account: IconAccount,
  "card-account-details": IconCardAccountDetails,
  "card-text": IconCardText,
  "help-circle": IconHelpCircle,
  nfc: IconNFC,
  "original-characters-check-active": OriginalCharactersCheckActive,
  "original-characters-check-inactive": OriginalCharactersCheckInactive,
  "view-dashboard": IconViewDashboard,
  "account-question": IconAccountQuestion,
  "account-search": IconAccountSearch,
  power: IconPower,
  logout: IconLogout,
  "alert-circle": IconAlertCircle,
  information: IconInformation,
  check: IconCheck,
  "check-circle": IconCheckCircle,
  magnify: IconMagnify,
  "rotate-right": IconRotateRight,
  "chevron-down": IconChevronDown,
  "chevron-left": IconChevronLeft,
  "chevron-right": IconChevronRight,
  "chevron-up": IconChevronUp,
  "content-copy": IconContentCopy,
  "open-in-new": IconOpenInNew,
  newspaper: IconNewspaper,
  refresh: IconRefresh,
  "type-game": TypeGame,
  "compliance-review": ComplianceReview,
  "qr-code": QRCode,
  soundOn: IconSoundOn,
  soundOff: IconSoundOff,
  "dark-mode": DarkMode,
  "arrow-up": ArrowUp,
  "arrow-down": ArrowDown,
  "no-media-image": IconNoMediaImage
};

export default {
  comments: icons,
  props: {
    name: {
      type: String,
      validator: val => {
        return Object.keys(icons).includes(val);
      }
    }
  },
  computed: {
    iconComponent() {
      return icons[this.name];
    }
  }
};
</script>

<style scoped>
svg {
  width: 1em;
  fill: currentColor;
}
</style>
